var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("AUTHORIZED REPRESENTATIVE")]),_c('h4',[_vm._v(" A person duly authorized by HMI to approve the provision of medical services or claims reimbursements to a Member. ")])])
}]

export { render, staticRenderFns }